module.exports = __webpack_public_path__ + "static/app-announce-a37529af62629a02220a3be33d01b3c9.png";